import styled from "styled-components";

export default styled.div`
  .group-container {
    .group-divider {
      margin-bottom: 0.5rem;
      margin-top: 0.5rem;
      margin-left: 1rem;
      margin-right: 1rem;
      opacity: 0.6;
    }
  }

  @media screen and (max-width: 768px) {
    .group-list-container {
      padding: 0px;

      .group-container {
        .group-divider {
          margin-bottom: 0.75rem;
          margin-top: 0.75rem;
        }
      }
    }
  }
`;
